import { authStore } from '../state/auth.js';
import { api } from '../api/client.js';
import { getRouter } from '../router.js';

interface LoginResponse {
  user: { id: number; login: string; role: string; email: string | null };
  csrfToken: string;
}

export async function loginPage(): Promise<HTMLElement> {
  const router = getRouter();
  const page = document.createElement('div');
  page.className = 'page page--login';
  page.setAttribute('data-title', 'Вход');

  const container = document.createElement('div');
  container.className = 'login-container';

  const title = document.createElement('h1');
  title.className = 'login-title';
  title.textContent = 'Админ-панель';
  container.appendChild(title);

  const form = document.createElement('form');
  form.className = 'login-form';
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    const loginInput = form.querySelector<HTMLInputElement>('#login');
    const passwordInput = form.querySelector<HTMLInputElement>('#password');
    const errorEl = form.querySelector('.login-error');
    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    
    if (!loginInput || !passwordInput || !submitBtn) return;

    const login = loginInput.value.trim();
    const password = passwordInput.value;

    if (!login || !password) {
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Вход...';
    if (errorEl) errorEl.textContent = '';

    try {
      const data = await api.post<LoginResponse>('/auth/login', { login, password });
      
      // Update auth store
      authStore.setState({ user: data.user, csrfToken: data.csrfToken, isLoading: false });
      
      // Redirect to admin
      router.navigate('/admin');
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err instanceof Error ? err.message : 'Ошибка входа';
      }
      submitBtn.disabled = false;
      submitBtn.textContent = 'Войти';
    }
  });

  form.innerHTML = `
    <div class="login-field">
      <label for="login">Логин</label>
      <input type="text" id="login" name="login" required autocomplete="username">
    </div>
    <div class="login-field">
      <label for="password">Пароль</label>
      <input type="password" id="password" name="password" required autocomplete="current-password">
    </div>
    <div class="login-error" style="color: var(--color-error, #d32f2f); min-height: 1.5em;"></div>
    <button type="submit" class="login-btn">Войти</button>
  `;

  container.appendChild(form);
  page.appendChild(container);

  return page;
}